import { AxiosResponse } from "axios";
import MiMPrivateService from "./MiMPrivateService";
import { IServiceResponse } from "../interfaces/General/IServiceResponse";
import { ITag } from "../interfaces/Tag/ITag";

class TagService extends MiMPrivateService {
  getTag(): Promise<AxiosResponse<IServiceResponse<ITag[]>>> {
    return this.http.get("v1/tags");
  }
}

export default TagService;
